/* LED Auto – product page: gallery, variant picker, stock line, quantity, sticky add-to-cart */
(() => {
  const init = (root) => {
    if (!root || root.dataset.ledInit) return;
    root.dataset.ledInit = '1';

    const dataEl = root.querySelector('[data-led-variants]');
    let variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }

    const form = document.getElementById(root.dataset.formId);

    /* Move the sticky bar to <body> so no transformed/overflow theme wrapper can trap
       its position:fixed. It keeps the .led-pdp class for colours, fonts and the
       mobile-only rule. Old copies (theme editor re-render) are removed first. */
    const sticky = root.querySelector('[data-sticky]');
    if (sticky) {
      document.querySelectorAll(`[data-led-for="${root.dataset.section}"]`).forEach((el) => el.remove());
      sticky.dataset.ledFor = root.dataset.section;
      sticky.classList.add('led-pdp');
      sticky.style.setProperty('--led-accent', root.style.getPropertyValue('--led-accent'));
      document.body.appendChild(sticky);
    }
    // query inside the section AND the moved sticky bar
    const qa = (sel) => [...root.querySelectorAll(sel), ...(sticky ? sticky.querySelectorAll(sel) : [])];
    const labels = {
      add: root.dataset.labelAdd,
      sold: root.dataset.labelSold,
      unavailable: root.dataset.labelUnavailable,
    };

    /* ---------- Gallery ---------- */
    const gallery = root.querySelector('[data-gallery]');
    const slides = gallery ? Array.from(gallery.children) : [];
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    let current = 0;

    const setActive = (i) => {
      current = i;
      dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
    };
    const goTo = (i, smooth = true) => {
      if (!gallery || !slides[i]) return;
      gallery.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };

    if (gallery && slides.length > 1) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((e) => { if (e.isIntersecting) setActive(slides.indexOf(e.target)); }),
        { root: gallery, threshold: 0.6 }
      );
      slides.forEach((s) => io.observe(s));
      dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
      root.querySelector('[data-prev]')?.addEventListener('click', () => goTo(Math.max(0, current - 1)));
      root.querySelector('[data-next]')?.addEventListener('click', () => goTo(Math.min(slides.length - 1, current + 1)));
      gallery.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, current + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current - 1)); }
      });
    }

    const goToMedia = (mediaId) => {
      if (!mediaId) return;
      const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (i > -1) goTo(i);
    };

    /* ---------- Quantity (main counter + synced copy in the sticky bar) ---------- */
    const mainQty = root.querySelector('.led-pdp__buy .led-pdp__qty');
    const stickyBtn = sticky?.querySelector('.led-pdp__sticky-btn');
    if (stickyBtn && !stickyBtn.querySelector('svg')) {
      // icon-only cart button; the text label stays for screen readers (and as aria-label)
      stickyBtn.insertAdjacentHTML('afterbegin', '<svg aria-hidden="true" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h8.7a1 1 0 0 0 1-.8L20 8H6.2"></path><circle cx="9.5" cy="20" r="1.3"></circle><circle cx="17" cy="20" r="1.3"></circle></svg>');
      const lbl = stickyBtn.querySelector('[data-atc-label]');
      if (lbl) stickyBtn.setAttribute('aria-label', lbl.textContent.trim());
    }
    if (mainQty && stickyBtn && !sticky.querySelector('.led-pdp__qty')) {
      const copy = mainQty.cloneNode(true);
      copy.classList.add('led-pdp__qty--sticky');
      const copyInput = copy.querySelector('input');
      ['name', 'id', 'form'].forEach((a) => copyInput.removeAttribute(a)); // only the main input is submitted
      stickyBtn.parentNode.insertBefore(copy, stickyBtn);
    }
    const qtyInputs = qa('.led-pdp__qty input');
    const setQty = (value) => {
      const v = Math.max(1, parseInt(value, 10) || 1);
      qtyInputs.forEach((i) => { i.value = v; });
    };
    qa('.led-pdp__qty').forEach((group) => {
      const input = group.querySelector('input');
      if (!input) return;
      group.querySelector('[data-qty-minus]')?.addEventListener('click', () => setQty((parseInt(input.value, 10) || 1) - 1));
      group.querySelector('[data-qty-plus]')?.addEventListener('click', () => setQty((parseInt(input.value, 10) || 1) + 1));
      input.addEventListener('input', () => {
        const v = parseInt(input.value, 10);
        if (v >= 1) qtyInputs.forEach((i) => { if (i !== input) i.value = v; });
      });
      input.addEventListener('change', () => setQty(input.value));
    });

    /* ---------- Stock line ---------- */
    const stock = root.querySelector('[data-stock]');
    const updateStock = (v) => {
      if (!stock) return;
      const threshold = parseInt(stock.dataset.threshold, 10) || 0;
      let state = 'instock';
      if (!v || !v.available) state = 'soldout';
      else if (v.tracked && v.qty <= 0) state = 'backorder';
      else if (v.tracked && v.qty <= threshold) state = 'low';
      const key = 'text' + state.charAt(0).toUpperCase() + state.slice(1);
      stock.dataset.state = state;
      const txt = stock.querySelector('[data-stock-text]');
      if (txt) txt.textContent = (stock.dataset[key] || '').replace('[count]', v ? v.qty : '');
    };

    /* ---------- Buttons ---------- */
    const atcButtons = qa('[data-atc]');
    const setButtons = (enabled, text) => {
      atcButtons.forEach((b) => {
        b.disabled = !enabled;
        const l = b.querySelector('[data-atc-label]');
        if (l) l.textContent = text;
        if (b.classList.contains('led-pdp__sticky-btn')) b.setAttribute('aria-label', text);
      });
    };

    /* ---------- Variant picker ---------- */
    const picker = root.querySelector('[data-variant-picker]');
    if (picker && variants.length) {
      const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
      const selected = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value);

      const markAvailability = (sel) => {
        fieldsets.forEach((fs, idx) => {
          fs.querySelectorAll('input').forEach((input) => {
            const ok = variants.some((v) =>
              v.available && v.options[idx] === input.value &&
              v.options.every((o, j) => j === idx || o === sel[j])
            );
            input.nextElementSibling?.classList.toggle('is-unavailable', !ok);
          });
        });
      };

      const apply = () => {
        const sel = selected();
        fieldsets.forEach((fs, i) => {
          const span = fs.querySelector('[data-selected-value]');
          if (span) span.textContent = sel[i] || '';
        });
        markAvailability(sel);

        const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        const idInput = form?.querySelector('[name="id"]');

        if (!v) {
          setButtons(false, labels.unavailable);
          updateStock(null);
          return;
        }

        if (idInput) {
          idInput.value = v.id;
          idInput.disabled = false;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        qa('[data-price]').forEach((el) => { el.innerHTML = v.price; });
        qa('[data-compare]').forEach((el) => {
          el.innerHTML = v.compare || '';
          el.hidden = !v.compare;
        });
        qa('[data-variant-title]').forEach((el) => { el.textContent = v.title; });

        setButtons(v.available, v.available ? labels.add : labels.sold);
        updateStock(v);
        goToMedia(v.media);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };

      picker.addEventListener('change', apply);
      markAvailability(selected());
    }

    /* ---------- Sticky add-to-cart ---------- */
    const mainAtc = root.querySelector('[data-main-atc]');
    if (sticky && mainAtc) {
      const show = (visible) => {
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        sticky.inert = !visible;
      };
      /* Loading state: Dawn's product-form marks only the main button with .loading while
         the item is added. Mirror that on the sticky cart button (spinner instead of icon). */
      if (stickyBtn) {
        const syncLoading = () => {
          const busy = mainAtc.classList.contains('loading') || mainAtc.getAttribute('aria-disabled') === 'true';
          stickyBtn.classList.toggle('is-loading', busy);
          if (busy) stickyBtn.setAttribute('aria-busy', 'true');
          else stickyBtn.removeAttribute('aria-busy');
        };
        new MutationObserver(syncLoading).observe(mainAtc, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
        // instant feedback on tap, before the theme script reacts; safety reset after 10 s
        stickyBtn.addEventListener('click', () => {
          if (stickyBtn.disabled) return;
          stickyBtn.classList.add('is-loading');
          clearTimeout(stickyBtn._ledT);
          stickyBtn._ledT = setTimeout(syncLoading, 10000);
        });
      }
      new IntersectionObserver(([entry]) => {
        // show only once the main button has scrolled up out of view
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(mainAtc);
    }
  };

  /* Mobile header search: magnifier button next to the menu icon + drop-down search field.
     Added by script so no theme header rule can hide it; CSS shows it on phones only. */
  const addHeaderSearch = () => {
    const header = document.querySelector('.header-wrapper > .header');
    if (!header || header.querySelector('.led-hdr-search')) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const de = (document.documentElement.lang || '').toLowerCase().startsWith('de');
    const label = de ? 'Suche' : 'Search';
    const icon = '<svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4-4"></path></svg>';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'led-hdr-search';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'LedHeaderSearch');
    btn.innerHTML = icon;

    const panel = document.createElement('form');
    panel.id = 'LedHeaderSearch';
    panel.className = 'led-hdr-search-panel';
    panel.action = root + 'search';
    panel.method = 'get';
    panel.setAttribute('role', 'search');
    panel.hidden = true;
    panel.innerHTML =
      '<input type="search" name="q" autocomplete="off" aria-label="' + label + '" placeholder="' +
      (de ? 'Artikelnummer oder Suchbegriff' : 'Part number or keyword') + '">' +
      '<input type="hidden" name="options[prefix]" value="last">' +
      '<button type="submit" aria-label="' + label + '">' + icon + '</button>';

    btn.addEventListener('click', () => {
      const open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('input[name="q"]').focus();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });

    header.appendChild(btn);
    header.insertAdjacentElement('afterend', panel);
  };

  const boot = () => {
    addHeaderSearch();
    document.querySelectorAll('[data-led-pdp]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-led-pdp]')));
})();
